import {Component, OnInit, ViewChild} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNGConfig } from 'primeng/api';
import { LanguageService } from '@service/language.service';
import { NotificationService } from '@service/notification.service';
import { Toast } from 'primeng/toast';
import { IndexedDbService } from '@service/indexeddb.service';
import { MessagesService } from '@core/_services/messages.service';
import { WebPushService } from '@service/webpush.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [LanguageService],
})
export class AppComponent implements OnInit{

    topbarTheme: string = 'dark';

    menuTheme: string = 'dark';

    layoutMode: string = 'light';

    menuMode: string = 'horizontal';

    inlineMenuPosition: string = 'bottom';

    inputStyle: string = 'filled';

    ripple: boolean = true;

    isRTL: boolean = false;

    public currentLanguage: string = 'fr';
    public loading = false;
    public languageIsLoaded: boolean  = false;
    @ViewChild('toast') public toast: Toast;

    constructor(public primengConfig: PrimeNGConfig, private translate: TranslateService, public languageService: LanguageService,
        private notifService: NotificationService,
        private indexedDbService: IndexedDbService,
        private webPushService: WebPushService,
        protected _messageService: MessagesService,) {
        let wInternal: any;
        if (localStorage.getItem('intern')) {
            wInternal = JSON.parse(atob(localStorage.getItem('intern')));
            this._messageService.setToastDuration(wInternal.toastDurationValue);
            if (wInternal.currentLanguage !== undefined) {
                this.currentLanguage = wInternal.currentLanguage;
            } else {
                this.currentLanguage = 'fr';
            }
            this.init();            
        }        
    }

    private async init() {
        this.loading = true;
        this.translate.setDefaultLang(this.currentLanguage);
        await this.languageService.loadCurrentLanguage(this.currentLanguage); 
        this.languageIsLoaded = true;
        await this.indexedDbService.getVariables();
        await this.indexedDbService.getGroupVariables();
        this.loading = false;
    }

    ngOnInit() {
        this.primengConfig.ripple = true;
        this.webPushService.requestPermission();
    }

    public onConfirm(aData) {
        this.notifService.confirmNotify(aData.idNotif);
        this.clearToast(aData.idNotif);
    }

    private clearToast(aId) {
        this.toast.messages = this.toast.messages.filter(item=> {
            return item.data.idNotif !== aId;
        });
    }

    public async onClose(aData) {
        if (aData !== null) {
            await this.notifService.rejectNotify(aData.message.data.idNotif);
        }
    }
}
